import {Component, OnInit} from "@angular/core";
import {Subscription} from "rxjs/Subscription";
import {NGXLogger} from "ngx-logger";
import {TranslateService} from "@ngx-translate/core";
import {SharedService} from "../../shared/shared.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DonationService} from "../../payment/Donation.Services";

@Component({
  selector: 'donation-fail',
  templateUrl: './donation-fail.component.html'
})
export class DonationFailComponent implements OnInit {
  lan: string;
  subscription: Subscription;
  constructor(private logger: NGXLogger,
              private translate: TranslateService, private sharedService: SharedService, private router: Router,
              private activatedRoute: ActivatedRoute, private donationService: DonationService) {
  }
  lang: string;
  url: any;

  isSeries: boolean = false;

  ngOnInit() {
    this.sharedService.refreshData();

    window.scroll(0, 0);
    this.lang = localStorage.getItem("lang");
    this.logger.debug('language is >>>>>>>>>>>' + this.lang);

    if (this.lang == "") {
      this.translate.use("ba");
      localStorage.setItem("lang", "ba");
    } else {
      this.translate.use(this.lang);
      localStorage.setItem("lang", this.lang);
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/donation/donatio-return-url/donation-fail.component.ts